import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

const initialState = {
  data: {},
  loading: false,
};

const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action?.payload;
    },
    removeUser: (state, action) => {
      state.data = {};
    },
    setTimezone: (state, action) => {
      state.data.time_zone = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(PURGE, (state) => {
      return initialState;
    });
  },
});

export const { setUser, removeUser, setTimezone } = UserSlice.actions;
export default UserSlice.reducer;
